/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {WinPresentationController} from "../../WinPresentationController";
import {gsap, TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {BigWinView} from "./BigWinView";
import {Karen} from "../../../Karen";
import {KarenGameConfig} from "../../../KarenGameConfig";
import {IWinRatioConfig} from "../../../../core/config/WinRatio";
import {KarenParsedGameData} from "../../../server/data/KarenParsedGameData";
import {KarenSoundManager} from "../../../sound/KarenSoundManager";
import {KarenSoundConfig} from "../../../sound/KarenSoundConfig";
import {GameHelper} from "../../../../core/utils/GameHelper";
import {KarenReelController} from "../../../reels/KarenReelController";
import {KarenGameMode} from "../../../server/KarenGameMode";
import {TweenLite} from "gsap/gsap-core";
import {IBetWayWinData} from "../../../server/data/IKarenData";
import {KarenSymbol} from "../../../symbol/KarenSymbol";

export class BigWinController extends WinPresentationController {

    public _view: BigWinView;
    private _level: number = 0;
    private _levelTimeline: TimelineLite | null;
    private _isSkipped: boolean = false;
    private _abortEndTl: TweenLite;


    constructor() {
        super("BigWinController", true);
        this._view = new BigWinView();
    }

    protected hasWin(): boolean {
        return Karen.model.parsedGameData.currentWinRatioConfig!.bigWinLevel > -1;
    }

    protected async createWinAnimation(): Promise<any> {
        await new Promise<any>(resolve => {
            this.playBigWinLevel(0, resolve);
        });
    }

    protected skip(): void {
        if (this._levelTimeline && this._levelTimeline.isActive()) {
            this._levelTimeline.progress(1);
        }
        this._isSkipped = true;

    }

    private playBigWinLevel(level: number, resolve: (value:any) => void): void {
        this._isSkipped = false;
        if (level > Karen.model.parsedGameData.currentWinRatioConfig!.bigWinLevel) {
            const endtl: TimelineLite = gsap.timeline();
            endtl.add(() => {
                KarenSoundManager.playSoundEffect(KarenSoundConfig.BIG_WIN_ENDS);
                if (Karen.model.parsedGameData.brokeTheBank) {
                    KarenSoundManager.stopSoundEffect(KarenSoundConfig.FREESPIN_WIN_LOOP);
                    KarenSoundManager.playDoNotLoopSound(KarenSoundConfig.BIG_WIN_END_MUSIC_CAP_WIN);
                    KarenSoundManager.playSoundEffect(KarenSoundConfig.CAP_WIN_COUNTUP);
                } else {
                    KarenSoundManager.playDoNotLoopSound(KarenSoundConfig.BIG_WIN_END_MUSIC);
                }
                KarenSoundManager.stopSoundEffect(KarenSoundConfig.BIG_WIN_LEVEL[this._level]);
                KarenSoundManager.stopSoundEffect(KarenSoundConfig.BIG_WIN_MUSIC[this._level]);
            });
            if (!Karen.model.parsedGameData.brokeTheBank) {
                endtl.to({}, {duration: 1.7});
            }
            Karen.bigWinCountUp.stay();
            this._view.playEnding(level);
            endtl.add(() => {
                if (!Karen.model.parsedGameData.brokeTheBank) {
                    if (GameHelper.isFreeSpin(Karen.model.parsedGameData.mode)) {
                        if (GameHelper.isFreeSpin(Karen.model.parsedGameData.nextMode)) {
                            KarenSoundManager.fadeFSGameSound(200, 1);
                            let winRatio = Karen.model.parsedGameData.currentWinRatioConfig?.ratio!;
                            if (winRatio && winRatio > KarenGameConfig.WIN_RATIOS[2].ratio && Karen.model.parsedGameData.mode === KarenGameMode.FREESPIN) {
                                KarenSoundManager.playFSLoopSound();
                            }
                            //#228
                        }
                    } else {
                        KarenSoundManager.fadeMusic(1, 400, KarenSoundConfig.MAIN_GAME_MUSIC);
                        //#232
                    }
                    endtl.add(() => {
                        this.playEnding();
                        Karen.bigWinCountUp.remove();
                    }, 2);
                    endtl.add(this._view.remove(), 2);
                    endtl.add(() => {
                        resolve(undefined);
                    }, endtl.totalDuration());
                } else {
                    resolve(undefined);
                    this.playEnding();
                    Karen.bigWinCountUp.remove();
                    this._view.remove();
                }
            });
            Karen.bigWinCountUp.waysText = Karen.model.parsedGameData.totalNumberOfCombinations;
            this._levelTimeline = endtl;
        } else {
            this._flowStateController.setSkipCallback(() => this.skip!());
            const tl: TimelineLite = gsap.timeline({paused: true});
            const playingTL: TimelineLite = gsap.timeline({
                onComplete: () => {
                    tl!.play(0);
                }
            });
            playingTL.add(() => {
                this._level = level;
                if (level > 0) {
                    KarenSoundManager.fadeAndStopSound({
                        name: KarenSoundConfig.BIG_WIN_MUSIC[level - 1],
                        to: 0,
                        duration: 100
                    });
                    KarenSoundManager.stopSoundEffect(KarenSoundConfig.BIG_WIN_LEVEL[level - 1]);
                    KarenSoundManager.stopSoundEffect(KarenSoundConfig.BIG_WIN_MUSIC[level - 1]);
                } else {
                    KarenSoundManager.stopSoundEffect(KarenSoundConfig.BIGWIN_INTRO);
                    KarenSoundManager.stopSoundEffect(KarenSoundConfig.BIGWIN_INTRO_MUSIC);
                }
                KarenSoundManager.playSoundEffect(KarenSoundConfig.BIG_WIN_LEVEL[level]);
                KarenSoundManager.playDoNotLoopSound(KarenSoundConfig.BIG_WIN_MUSIC[level]);
            });
            playingTL.add(this.getLevelAnimation(level));
            tl.add(() => {
            }, 0.01);
            tl.add(() => {
                if (level < Karen.model.parsedGameData.currentWinRatioConfig!.bigWinLevel && this._isSkipped) {
                    let bigWinTl: TimelineLite = this._view.playBigWinEnding(level);
                    if (this._abortEndTl && this._abortEndTl.totalDuration()) {
                        this._abortEndTl.kill();
                    }
                    this._abortEndTl = gsap.delayedCall(bigWinTl.duration(), () => {
                        console.log("level: Sound Stopping", level);
                        this.playBigWinLevel(level + 1, resolve);
                    });
                } else {
                    this.playBigWinLevel(level + 1, resolve);
                }
            }, 0);
            this._levelTimeline = playingTL;
        }
    }

    private getLevelAnimation(level: number): TimelineLite {
        const data: KarenParsedGameData = Karen.model.parsedGameData;
        const currentRatio: IWinRatioConfig = KarenGameConfig.WIN_RATIOS.find(r => r.bigWinLevel === level)!;
        const from: number = level === 0 ? 0 : data.playedBetValue * currentRatio.ratio;
        const to: number = level === data.currentWinRatioConfig!.bigWinLevel ? data.singleWin : data.playedBetValue * KarenGameConfig.WIN_RATIOS.find(r => r.bigWinLevel === (level + 1))!.ratio;
        const duration: number = currentRatio.duration;
        const tl: TimelineLite = gsap.timeline();
        tl.add([
            () => {Karen.bigWinCountUp.scale.set(1.2)},
            this._view.getLevelAnimation(level),
            Karen.bigWinCountUp.getCountUpAnimation(from, to, duration),
            Karen.bigWinCountUp.setCountUpEffects(),
            gsap.to(Karen.bigWinCountUp.scale, {duration: duration, x: 1, y: 1, ease: `power4.out`})
        ]);
        return tl
    }

    private playEnding(): void {
        this._flowStateController.setSkipCallback();
        if (!Karen.model.parsedGameData.brokeTheBank) {
            SlotGame.keypadPlugin.setWin(Karen.model.parsedGameData.totalWin, Karen.model.parsedGameData.showTotalWin, GameHelper.isWinBelowStake());
        }
        //resolve();
        const tl: TimelineLite = gsap.timeline();
        // TODO: add ending animation.
    }
}
